import React, { useEffect, useState } from "react";
// import { Accordion, AccordionItem } from "@heroui/react";
// import Header from "../Layouts/Header.jsx";
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
} from "@heroui/react";
import MarketList from "./MarketList.jsx";
import { Spinner } from "@heroui/react";
import { Tabs, Tab, Card, CardBody } from "@heroui/react";
import { useSessionTimeout } from "../../hooks/useSessionTimeout.js";
import { useParams, useLocation } from "react-router-dom";
import { LoserIcon, WinnerIcon } from "../../components/HeaderSidebarIcons.jsx";
import { jwtDecode } from "jwt-decode";

const Markets = () => {
  const [groupedMarkets, setGroupedMarkets] = useState({});
  const [loading, setLoading] = useState(true);

  const [timedOut, setTimedOut] = useState(false);

  const { operatorId, userId } = useParams();
  const [resultHistory, setResultHistory] = useState([]);
  const [resultMatchHistory, setResultMatchHistory] = useState([]);
  const [rowLoading, setRowLoading] = useState({});

  const location = useLocation();
  // const navigate = useNavigate();
  const [betHistory, setBetHistory] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const [dateValue, setLast7] = useState([]); // store last 7 days

  const params = new URLSearchParams(location.search);
  const tokenFromUrl = params.get("token");
  const { userName } = jwtDecode(tokenFromUrl);

  if (timedOut === false) {
    localStorage.setItem("opid", operatorId);
    sessionStorage.setItem("opid", operatorId);
    localStorage.setItem("uid", userId);
    sessionStorage.setItem("uid", userId);
    localStorage.setItem("uname", userName);
    sessionStorage.setItem("uname", userName);
    localStorage.setItem("betType", "single");
    sessionStorage.setItem("betType", "single");
    if (tokenFromUrl) {
      localStorage.setItem("authToken", tokenFromUrl);
      sessionStorage.setItem("authToken", tokenFromUrl);
    }
  }
  const token = tokenFromUrl;

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  const handleTimeout = (type) => {
    console.log(`Session timed out due to: ${type}`);
    setTimedOut(true);
    // localStorage.clear();
    // sessionStorage.clear();
    // setTimedOut(true);
  };

  useSessionTimeout(token, handleTimeout);

  useEffect(() => {
    const getEvents = async (e) => {
      // setLoadingEvents(true);
      // Set headers with JWT token
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append(
        "Authorization",
        "Bearer " + localStorage.getItem("authToken")
      );
      // Request body
      // const urlencoded = {
      //   "event_id": props.event_id,
      // };
      // API request options
      let requestOptions = {
        method: "GET",
        headers: headers,
        // body: JSON.stringify(urlencoded),
      };
      // Fetch API Call
      await fetch(
        process.env.REACT_APP_API_HOST_OP +
          "/matches/" +
          operatorId +
          "/" +
          userId,
        requestOptions
      )
        .then((response) => {
          if (response.status === 401) {
            console.log("Unauthorized access. Please log in again.");
          } else {
            return response.json();
          }
        })
        .then((result) => {
          if (result.data) {
            const grouped = groupData(result.data);
            setGroupedMarkets(grouped);
            // setEventList(result.data);
          }
        })
        .catch((err) => {
          console.log("Error fetching events:", err);
        })
        .finally(() => {
          // setLoadingEvents(false);
        });
    };
    getEvents();
  }, [operatorId, userId]);

  const formatDateTime = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };
  useEffect(() => {
    const getBetHistory = async () => {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append(
        "Authorization",
        "Bearer " + localStorage.getItem("authToken")
        // "Bearer " +  tokenFromUrl
      );

      const requestOptions = {
        method: "GET",
        headers: headers,
      };

      await fetch(
        process.env.REACT_APP_API_HOST_OP +
          "/betHistory/" +
          operatorId +
          "/" +
          userId,
        requestOptions
      )
        .then((response) => {
          if (response.status === 401) {
            console.log("Unauthorized access. Please log in again.");
          } else {
            return response.json();
          }
        })
        .then((result) => {
          if (result.data) {
            setBetHistory(result.data);
          }
        })
        .catch((err) => {
          console.log("Error fetching bet history:", err);
        });
    };

    getBetHistory();
  }, [userId]);
  useEffect(() => {}, [betHistory]);

  const groupData = (data) => {
    const result = {};
    data.forEach((item) => {
      const { market_name, match_name } = item;
      if (!result[market_name]) {
        result[market_name] = {};
      }
      if (!result[market_name][match_name]) {
        result[market_name][match_name] = [];
      }
      result[market_name][match_name].push(item);
    });
    return result;
  };

  const getCleanResult = (val) => val?.trim() || "***";
  const getCleanJodiResult = (val) => val?.trim() || "**";

  useEffect(() => {
    const getResultHistory = async () => {
      try {
        const response = await fetch(
          process.env.REACT_APP_API_HOST_OP + "/result/history",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("authToken"),
            },
          }
        );

        if (response.status === 401) {
          console.log("Unauthorized access. Please log in again.");
          return;
        }

        const result = await response.json();
        if (result.success && result.data) {
          setResultHistory(result.data);
        } else {
          // If no real data, use dummy data for demo
          setResultHistory(result.data);
        }
      } catch (err) {
        console.log("Error fetching bet history:", err);
        // Use demo data if API fails
      }
    };

    getResultHistory();
  }, [userId]);

  const toggleRow = async (rowKey, matchName, referenceDate) => {
    setExpandedRows((prev) => {
      const isOpening = !prev[rowKey];
      const newState = isOpening ? { [rowKey]: true } : {};

      if (isOpening) {
        setRowLoading((p) => ({ ...p, [rowKey]: true }));
        if (!resultHistory[matchName]) {
          getMatchResultHistory(matchName, referenceDate, rowKey);
        } else {
          setTimeout(() => {
            setRowLoading((p) => ({ ...p, [rowKey]: false }));
          }, 1000);
        }
      }

      return newState;
    });

    const last7Days = getLast7DaysFromDate(referenceDate);
    // CLEAR previous data if empty
    if (last7Days && last7Days.length > 0) {
      setLast7(last7Days);
    } else {
      setLast7([]); // clear stale data
    }
  };

  const parseDate = (dateStr) => {
    if (!dateStr) return null;

    // If string is already ISO (YYYY-MM-DD)
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      return new Date(dateStr);
    }

    // If string is DD-MM-YYYY
    if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
      const [day, month, year] = dateStr.split("-").map(Number);
      return new Date(year, month - 1, day);
    }

    console.error("Unsupported date format:", dateStr);
    return null;
  };

  const getLast7DaysFromDate = (referenceDate) => {
    const baseDate = parseDate(referenceDate);
    if (!baseDate) return []; // stop if invalid

    const days = [];
    for (let i = 1; i <= 7; i++) {
      const d = new Date(baseDate);
      d.setDate(baseDate.getDate() - i);

      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();

      days.push({
        weekday: d.toLocaleDateString("en-GB", { weekday: "short" }),
        date: `${day}-${month}-${year}`,
      });
    }
    return days.reverse();
  };
  dateValue.forEach((day, index) => {});

  const formatToISO = (dateStr) => {
    const [day, month, year] = dateStr.split("-");
    return `${year}-${month}-${day}`;
  };

  const chunkArray = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };

  const getMatchResultHistory = async (matchName, referenceDate, rowKey) => {
    try {
      const headers = new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("jwt"),
      });

      const response = await fetch(
        `${process.env.REACT_APP_API_HOST_OP}/match/results`,
        {
          method: "POST",
          headers,
          body: JSON.stringify({ matchName, matchDate: referenceDate }),
        }
      );

      const result = await response.json();
      if (
        !response.ok ||
        !result.success ||
        !result.data ||
        result.data.length === 0
      ) {
        console.warn("No data for this match:", matchName, referenceDate);
        setResultMatchHistory({ weeks: [], weekRanges: [] }); // clear previous data
        if (rowKey !== undefined)
          setRowLoading((p) => ({ ...p, [rowKey]: false }));
        return;
      }

      const data = result.data;

      // Step 1: Map data by date
      const dataMap = {};
      data.forEach((item) => {
        if (!dataMap[item.matchDate]) {
          dataMap[item.matchDate] = {
            matchDate: item.matchDate,
            dayOfWeek: item.dayOfWeek,
            matchName: item.matchName,
            jodiOpen: "***",
            jodiClose: "***",
            singlePattiOpen: "***",
            singlePattiClose: "***",
            jodi1: "***",
            jodi2: "***",
            pattiOpen: "***",
            pattiClose: "***",
            totalJodiValue: "**",
            halfSangamClose: "***",
          };
        }

        switch (item.type_id) {
          case 1:
            dataMap[item.matchDate].jodiOpen = item.open_result;
            dataMap[item.matchDate].jodiClose = item.close_result;
            break;
          case 2:
            dataMap[item.matchDate].singlePattiOpen = item.open_result;
            dataMap[item.matchDate].singlePattiClose = item.close_result;
            break;
          case 3:
            dataMap[item.matchDate].jodi1 = item.open_result;
            dataMap[item.matchDate].jodi2 = item.close_result;
            break;
          case 4:
            dataMap[item.matchDate].pattiOpen = item.open_result;
            dataMap[item.matchDate].pattiClose = item.close_result;
            break;
          case 5:
            dataMap[item.matchDate].totalJodiValue = item.open_result;
            dataMap[item.matchDate].halfSangamClose = item.close_result;
            break;
        }
      });

      // Step 2: Get earliest available data date
      const dataDates = data.map((item) => {
        const [d, m, y] = item.matchDate.split("-").map(Number);
        return new Date(y, m - 1, d);
      });
      const earliestDate = new Date(Math.min(...dataDates));

      // Step 3: Generate all dates from referenceDate backward to earliestDate
      // Step 3: Generate all dates from referenceDate backward to earliestDate
      const [refDay, refMonth, refYear] = referenceDate.split("-").map(Number);
      let current = new Date(refYear, refMonth - 1, refDay); // start from day before referenceDate

      const filledDates = [];
      while (current >= earliestDate) {
        const dd = String(current.getDate()).padStart(2, "0");
        const mm = String(current.getMonth() + 1).padStart(2, "0");
        const yyyy = current.getFullYear();
        const dStr = `${dd}-${mm}-${yyyy}`;

        filledDates.push(
          dataMap[dStr] || {
            matchDate: dStr,
            dayOfWeek: current.toLocaleDateString("en-US", { weekday: "long" }),
            matchName: data[0]?.matchName || "N/A",
            jodiOpen: "***",
            jodiClose: "***",
            singlePattiOpen: "***",
            singlePattiClose: "***",
            jodi1: "***",
            jodi2: "***",
            pattiOpen: "***",
            pattiClose: "***",
            totalJodiValue: "**",
            halfSangamClose: "***",
          }
        );

        current.setDate(current.getDate() - 1);
      }

      // Step 4: Group by week Monday → Sunday
      const getMonday = (d) => {
        const date = new Date(d);
        const day = date.getDay();
        const diff = day === 0 ? -6 : 1 - day; // if Sunday, go back 6
        date.setDate(date.getDate() + diff);
        return date;
      };

      const weekMap = {};
      filledDates.forEach((item) => {
        const [dd, mm, yyyy] = item.matchDate.split("-").map(Number);
        const dateObj = new Date(yyyy, mm - 1, dd);
        const monday = getMonday(dateObj);

        const key = `${String(monday.getDate()).padStart(2, "0")}-${String(
          monday.getMonth() + 1
        ).padStart(2, "0")}-${monday.getFullYear()}`;

        if (!weekMap[key]) weekMap[key] = [];
        weekMap[key].push(item);
      });

      // const [refDay, refMonth, refYear] = referenceDate.split("-").map(Number);
      const refDateObj = new Date(refYear, refMonth - 1, refDay);

      const weeks = Object.entries(weekMap).map(([mondayStr, items]) => {
        const [d, m, y] = mondayStr.split("-").map(Number);
        const monday = new Date(y, m - 1, d);

        const fullWeek = [];
        for (let i = 0; i < 7; i++) {
          const current = new Date(monday);
          current.setDate(monday.getDate() + i);

          // Skip future dates
          if (current > refDateObj) break;

          const dd = String(current.getDate()).padStart(2, "0");
          const mm = String(current.getMonth() + 1).padStart(2, "0");
          const yyyy = current.getFullYear();
          const dateStr = `${dd}-${mm}-${yyyy}`;

          fullWeek.push(
            items.find((it) => it.matchDate === dateStr) || {
              matchDate: dateStr,
              dayOfWeek: current.toLocaleDateString("en-US", {
                weekday: "long",
              }),
              matchName: items[0]?.matchName || "N/A",
              jodiOpen: "***",
              jodiClose: "***",
              singlePattiOpen: "***",
              singlePattiClose: "***",
              jodi1: "***",
              jodi2: "***",
              pattiOpen: "***",
              pattiClose: "***",
              totalJodiValue: "**",
              halfSangamClose: "***",
            }
          );
        }

        return fullWeek;
      });

      // Step 6: Sort weeks by start date
      weeks.sort((a, b) => {
        const [ad, am, ay] = a[0].matchDate.split("-").map(Number);
        const [bd, bm, by] = b[0].matchDate.split("-").map(Number);
        return new Date(ay, am - 1, ad) - new Date(by, bm - 1, bd);
      });

      setResultMatchHistory({ weeks });

      // Suppose `weeks` is your array of arrays of dates
      const weekRanges = weeks.map((week) => {
        const startDate = week[0].matchDate;

        // For end date, pad to Sunday if week has fewer than 7 days
        const lastDay = week[week.length - 1].matchDate.split("-").map(Number);
        let endDateObj = new Date(lastDay[2], lastDay[1] - 1, lastDay[0]);

        const dayOfWeek = endDateObj.getDay(); // 0 = Sunday
        if (dayOfWeek !== 0) {
          // Add days until Sunday
          endDateObj.setDate(endDateObj.getDate() + (7 - dayOfWeek));
        }

        const dd = String(endDateObj.getDate()).padStart(2, "0");
        const mm = String(endDateObj.getMonth() + 1).padStart(2, "0");
        const yyyy = endDateObj.getFullYear();
        const endDate = `${dd}-${mm}-${yyyy}`;

        return `${startDate} to ${endDate}`;
      });
      setResultMatchHistory({ weeks, weekRanges });

      if (rowKey !== undefined)
        setTimeout(
          () => setRowLoading((p) => ({ ...p, [rowKey]: false })),
          1000
        );
    } catch (err) {
      console.error("Error fetching results:", err);
      if (rowKey !== undefined)
        setRowLoading((p) => ({ ...p, [rowKey]: false }));
    }
  };

  if (loading) {
    return (
      <div className="h-screen">
        <div className="flex items-center justify-center min-h-screen">
          <Spinner size="lg" variant="spinner" color="warning" />
        </div>
      </div>
    );
  }

  // Get last 7 days

  return (
    <div className="h-screen">
      <div className="px-1 mx-auto max-w-screen-xl md:max-w-screen-2xl 2xl:max-w-screen-lg lg:py-5">
        <Tabs aria-label="Options" variant="underlined" className="-mb-4">
          <Tab key="game" title="PLAY">
            {timedOut === false && (
              <div className="-mt-1.5">
                {Object.keys(groupedMarkets).length > 0 ? (
                  <div>
                    {Object.entries(groupedMarkets).map(
                      ([marketName, matches]) => (
                        <div className="py-1">
                          <div className="w-full bg-m_peach text-m_black mb-1">
                            <h1 className="px-3 py-1 font-semibold">
                              {marketName}
                            </h1>
                          </div>
                          <MarketList
                            marketName={marketName}
                            matches={matches}
                            operatorId={operatorId}
                            userId={userId}
                            tokenFromUrl={tokenFromUrl}
                          />
                        </div>
                      )
                    )}
                  </div>
                ) : (
                  <div className="flex items-center justify-center h-96">
                    <div className="text-center">
                      <h2 className="text-xl font-semibold text-gray-600">
                        No Markets Available
                      </h2>
                    </div>
                  </div>
                )}
              </div>
            )}
            {timedOut && (
              <div className="min-h-screen bg-admin_black flex flex-col items-center justify-center">
                <h1 className="text-white text-3xl font-semibold">
                  Session TimeOut.
                </h1>
              </div>
            )}
          </Tab>
          <Tab key="bets" title="BET HISTORY">
            <div className="container mx-auto px-4 py-0">
              {betHistory.length > 0 ? (
                betHistory.map((bet) => (
                  <Card
                    key={bet.id}
                    className="shadow-xl border border-gray-400 mb-3"
                    radius="sm"
                  >
                    <CardBody className="p-4 relative">
                      <div className="absolute left-0 top-0 bg-m_peach text-white text-center text-sm px-1.5 py-0.5 w-36 z-10 mb-2 capitalize">
                        {bet.type_name}
                      </div>

                      <div className="text-sm font-semibold text-m_red mb-2 mt-4">
                        {/* You can replace this with your actual market name or match name */}
                        {bet.market_name || bet.match_name} -{" "}
                        {bet.status === "open" ? "Open" : "Close"}
                        <span className="text-xs px-1 italic">
                          {bet.draw_time || formatDateTime(bet.created_on)}
                        </span>
                      </div>
                      <div class="grid grid-cols-3 gap-y-2 text-sm text-m_black">
                        <div>
                          <span class="font-medium">Digit :</span>
                          <span class="text-xs">{bet.digit}</span>
                        </div>

                        <div class="flex justify-center items-center gap-1">
                          <span class="font-medium">Stake :</span>
                          <span class="text-xs">
                            {" "}
                            {parseFloat(bet.stake).toFixed(2)}
                          </span>
                        </div>

                        <div class="text-center">
                          {bet.status_id === 4 ? (
                            <p className="text-yellow-600 text-sm italic text-center">
                              Bet Cancelled
                            </p>
                          ) : bet.status_id === 5 ? (
                            <p className="text-gray-500 text-sm italic text-center">
                              Bet Abandoned
                            </p>
                          ) : bet.status === "open" ? (
                            !bet.open_result || bet.open_result === "" ? (
                              <p className="text-red-500 text-sm italic text-center">
                                Pending, Wait for Result
                              </p>
                            ) : // text-sm text-m_black font-medium
                            bet.is_win === 1 ? (
                              <p className="flex items-center justify-center gap-1 text-green-600 text-sm italic text-center">
                                Congratulations, you won! <WinnerIcon />
                              </p>
                            ) : bet.is_win === 0 ? (
                              <p className="text-red-500 text-sm italic flex items-center justify-center gap-1">
                                Lose, Please try again. <LoserIcon />
                              </p>
                            ) : null
                          ) : bet.status === "close" ? (
                            !bet.close_result || bet.close_result === "" ? (
                              <p className="text-red-500 text-sm italic text-center">
                                Pending, Wait for Result
                              </p>
                            ) : bet.is_win === 1 ? (
                              <p className="flex items-center justify-center gap-1 text-green-600 text-sm italic text-center">
                                Congratulations, you won! <WinnerIcon />
                              </p>
                            ) : bet.is_win === 0 ? (
                              <p className="text-red-500 text-sm italic flex items-center justify-center gap-1">
                                Lose, Please try again. <LoserIcon />
                              </p>
                            ) : null
                          ) : null}
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                ))
              ) : (
                <div className="text-center text-gray-500 py-10">
                  No bet history found
                </div>
              )}
            </div>
          </Tab>
          <Tab
            key="results"
            title="RESULTS"
            color="primary"
            className="data-[state=active]:text-primary"
          >
            {Object.values(resultHistory).length > 0 ? (
              (() => {
                // Helper to parse DD-MM-YYYY into valid JS Date
                const parseDate = (dateStr) => {
                  if (!dateStr) return null;
                  const [day, month, year] = dateStr.split("-");
                  return new Date(`${year}-${month}-${day}`);
                };
                const allEntries = Object.values(resultHistory)
                  .filter((entries) => Array.isArray(entries) && entries[0])
                  .flat();

                // Step 2: Group by matchName
                const groupedByMatchName = {};
                allEntries.forEach((entry) => {
                  const matchName = entry.matchName || entry.match_name;
                  if (!groupedByMatchName[matchName])
                    groupedByMatchName[matchName] = [];
                  groupedByMatchName[matchName].push(entry);
                });

                // Step 3: For each matchName, pick the latest entry for each type_id
                const latestEntries = Object.values(groupedByMatchName).map(
                  (entries) => {
                    const singlePattiEntry = entries
                      .filter((e) => e.type_id === 2)
                      .sort(
                        (a, b) =>
                          parseDate(b.matchDate) - parseDate(a.matchDate)
                      )[0];

                    const jodiOpenEntry = entries
                      .filter((e) => e.type_id === 1)
                      .sort(
                        (a, b) =>
                          parseDate(b.matchDate) - parseDate(a.matchDate)
                      )[0];

                    const jodiCloseEntry = entries
                      .filter((e) => e.type_id === 5)
                      .sort(
                        (a, b) =>
                          parseDate(b.matchDate) - parseDate(a.matchDate)
                      )[0];

                    // Use any date from available entries for sorting
                    const referenceEntry = entries.sort(
                      (a, b) => parseDate(b.matchDate) - parseDate(a.matchDate)
                    )[0];

                    return {
                      referenceEntry,
                      singlePattiEntry,
                      jodiOpenEntry,
                      jodiCloseEntry,
                    };
                  }
                );

                // Step 4: Sort by date descending
                latestEntries.sort(
                  (a, b) =>
                    parseDate(b.referenceEntry.matchDate) -
                    parseDate(a.referenceEntry.matchDate)
                );

                // Step 5: Map to JSX
                const rows = latestEntries.map(
                  (
                    {
                      referenceEntry,
                      singlePattiEntry,
                      jodiOpenEntry,
                      jodiCloseEntry,
                    },
                    index
                  ) => {
                    const matchName =
                      referenceEntry.matchName ||
                      referenceEntry.match_name ||
                      "-";

                    const clean = (val) => val?.trim() || null;

                    const spOpen =
                      clean(singlePattiEntry?.open_result) || "***";
                    const spClose =
                      clean(singlePattiEntry?.close_result) || "***";

                    const jodiEntry = jodiOpenEntry || jodiCloseEntry; // assuming jodiOpenEntry is already the latest type_id 1 entry

                    let jodiOp = clean(jodiEntry?.open_result) || "*";
                    let jodiCls = clean(jodiEntry?.close_result) || "*";

                    let jodiJoin = `${jodiOp}${jodiCls}`;
                    if (jodiJoin === "**") jodiJoin = "*";
                    let jodiResult = "**";
                    if (jodiOp !== "*")
                      jodiResult = jodiOp.length === 1 ? `${jodiOp}*` : jodiOp;
                    const isEmpty =
                      spOpen === "***" &&
                      spClose === "***" &&
                      (jodiResult === "*" || jodiResult === "**");
                    if (isEmpty) return;

                    const combinedResult = `${spOpen}-${jodiJoin}-${spClose}`;
                    const rowKey = referenceEntry.match_id || index;
                    const formattedDate = referenceEntry.matchDate
                      ? parseDate(referenceEntry.matchDate).toLocaleDateString()
                      : "-";
                    const last7 = resultMatchHistory?.weeks || [];
                    const from = dateValue?.[0]?.date;
                    const to = dateValue?.[dateValue.length - 1]?.date;

                    const parseDMY = (str) => {
                      if (!str) return null;
                      const [day, month, year] = str.split("-");
                      if (!day || !month || !year) return null;
                      return new Date(`${year}-${month}-${day}`);
                    };

                    const formatDate = (str, type = "full") => {
                      if (!str) return "";
                      const date = parseDMY(str);
                      if (!date) return str;

                      if (type === "full") {
                        return date.toLocaleDateString("en-GB");
                      }
                      if (type === "short") {
                        return date.toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                        });
                      }
                      return str;
                    };

                    return (
                      <React.Fragment key={rowKey}>
                        <TableRow
                          className="border cursor-pointer hover:bg-m_peach/10 transition-all duration-200 group"
                          onClick={() =>
                            toggleRow(
                              rowKey,
                              matchName,
                              referenceEntry.matchDate
                            )
                          }
                        >
                          <TableCell className="py-3 px-4 font-medium text-gray-700 group-hover:text-m_black">
                            {formattedDate}
                          </TableCell>
                          <TableCell className="py-3 px-4 font-semibold text-m_black">
                            {matchName}
                          </TableCell>
                          <TableCell className="py-3 px-3">
                            <div className="flex items-center justify-between">
                              <div className="flex items-center gap-1">
                                <span className="text-m_black font-bold text-md">
                                  {combinedResult.split("-")[0]}-
                                </span>
                                <span className="text-m_black font-bold text-md">
                                  {combinedResult.split("-")[1]}-
                                </span>
                                <span className="text-m_black font-bold text-md">
                                  {combinedResult.split("-")[2]}
                                </span>
                              </div>
                              <div className="flex items-center gap-2">
                                <div
                                  className={`w-4 h-4 transition-transform duration-200 ${
                                    expandedRows[rowKey] ? "rotate-180" : ""
                                  }`}
                                >
                                  <svg
                                    className="w-full h-full text-m_peach"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M19 9l-7 7-7-7"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </TableCell>
                        </TableRow>
                        {expandedRows[rowKey] && (
                          <TableRow className="">
                            <TableCell colSpan={3} className="p-0">
                              <div className="p-1 mb-1">
                                <div className="rounded border-2 border-m_peach bg-gradient-to-b from-m_peach/10 to-white shadow-lg">
                                  <div className="divide-y divide-m_peach/30">
                                    <div className="px-1 pt-2">
                                      {rowLoading[rowKey] ? (
                                        <div className="w-full flex items-center justify-center py-6">
                                          <Spinner
                                            size="lg"
                                            variant="dots"
                                            color="warning"
                                          />
                                        </div>
                                      ) : (
                                        <>
                                          <div className="hidden md:flex items-center gap-3 mb-1">
                                            {last7 && last7.length > 0 && (
                                              <div className="w-20 text-sm font-semibold text-m_black bg-m_peach/20 px-2 py-1 rounded">
                                                Date
                                              </div>
                                            )}
                                            <div className="grid grid-cols-7 gap-3 flex-1">
                                              {last7[0]?.map((day, i) => {
                                                const shortDay =
                                                  day.dayOfWeek?.substring(
                                                    0,
                                                    3
                                                  ) || "";
                                                return (
                                                  <span
                                                    key={i}
                                                    className="text-sm text-m_black font-bold whitespace-nowrap text-center bg-m_peach/30 px-1 py-0.5 rounded"
                                                  >
                                                    {shortDay}
                                                  </span>
                                                );
                                              })}
                                            </div>
                                          </div>
                                          {/* Mobile: single sticky header for days, rows per-week */}
                                          <div className="md:hidden w-full mb-1">
                                            {last7 && last7.length > 0 ? (
                                              <>
                                                {/* Single header row (Date + Days) */}
                                                <div className="grid grid-cols-[42px_repeat(7,minmax(0,1fr))] gap-1 mb-1">
                                                  <div className="flex items-center justify-center bg-m_peach/20 text-[10px] font-bold text-m_black rounded">
                                                    Date
                                                  </div>
                                                  {last7[0].map((day, idx) => {
                                                    const shortDay =
                                                      day.dayOfWeek?.substring(
                                                        0,
                                                        3
                                                      ) || "";
                                                    return (
                                                      <span
                                                        key={idx}
                                                        className="text-[10px] font-bold text-center text-m_black bg-m_peach/30 p-0.3 rounded"
                                                      >
                                                        {shortDay}
                                                      </span>
                                                    );
                                                  })}
                                                </div>

                                                {/* Per-week rows only show date-range + 7 cells */}
                                                {last7.map((week, wIdx) => {
                                                  const startOfWeek =
                                                    week[0]?.matchDate;
                                                  const lastDayStr =
                                                    week[week.length - 1]
                                                      ?.matchDate;
                                                  let endPadded = "-";
                                                  if (lastDayStr) {
                                                    const [d, m, y] = lastDayStr
                                                      .split("-")
                                                      .map(Number);
                                                    const dateObj = new Date(
                                                      y,
                                                      m - 1,
                                                      d
                                                    );
                                                    const day =
                                                      dateObj.getDay();
                                                    if (day !== 0)
                                                      dateObj.setDate(
                                                        dateObj.getDate() +
                                                          (7 - day)
                                                      );
                                                    const dd = String(
                                                      dateObj.getDate()
                                                    ).padStart(2, "0");
                                                    const mm = String(
                                                      dateObj.getMonth() + 1
                                                    ).padStart(2, "0");
                                                    const yyyy =
                                                      dateObj.getFullYear();
                                                    endPadded = `${dd}-${mm}-${yyyy}`;
                                                  }

                                                  return (
                                                    <div
                                                      key={wIdx}
                                                      className="grid grid-cols-[42px_repeat(7,minmax(0,1fr))] gap-[2px] mb-1"
                                                    >
                                                      {/* <div className="flex flex-col items-center justify-center text-center pt-1 px-1 text-[9px] text-m_black leading-tight py-2.5"> */}
                                                      <div className="flex flex-col items-center justify-center text-center pt-0.5 px-1 text-[10px] text-m_black leading-tight py-1.5 border bg-white">
                                                        <span className="font-bold">
                                                          {startOfWeek || "-"}
                                                        </span>
                                                        <span className="text-[8px]">
                                                          to
                                                        </span>
                                                        <span className="font-bold">
                                                          {endPadded}
                                                        </span>
                                                      </div>
                                                      {week.map((day, dIdx) => {
                                                        const openDigits = (
                                                          day.singlePattiOpen ||
                                                          "***"
                                                        )
                                                          .toString()
                                                          .split("");
                                                        const closeDigits = (
                                                          day.singlePattiClose ||
                                                          "***"
                                                        )
                                                          .toString()
                                                          .split("");
                                                      let jodiValue = "";
                                                        const openValRaw =
                                                          day.jodiOpen
                                                            ?.toString()
                                                            .trim();
                                                        const closeValRaw =
                                                          day.jodiClose
                                                            ?.toString()
                                                            .trim();

                                                        // Treat "***" as empty
                                                        const openVal =
                                                          openValRaw &&
                                                          openValRaw !== "***"
                                                            ? openValRaw
                                                            : "";
                                                        const closeVal =
                                                          closeValRaw &&
                                                          closeValRaw !== "***"
                                                            ? closeValRaw
                                                            : "";
                                                        const total =
                                                          day.totalJodiValue
                                                            ?.toString()
                                                            .trim();

                                                        if (
                                                          total &&
                                                          total !== "**"
                                                        ) {
                                                          jodiValue = total;
                                                        } else if (
                                                          openVal &&
                                                          closeVal
                                                        ) {
                                                          jodiValue = `${openVal}-${closeVal}`;
                                                        } else if (openVal) {
                                                          jodiValue = `${openVal}*`;
                                                        } else if (closeVal) {
                                                          jodiValue = `*${closeVal}`;
                                                        } else {
                                                          jodiValue = "**";
                                                        }
                                                        const redJodis = [
                                                          "11",
                                                          "22",
                                                          "33",
                                                          "44",
                                                          "55",
                                                          "66",
                                                          "77",
                                                          "88",
                                                          "99",
                                                          "00",
                                                          "16",
                                                          "61",
                                                          "27",
                                                          "72",
                                                          "38",
                                                          "83",
                                                          "49",
                                                          "94",
                                                          "50",
                                                          "05",
                                                        ];
                                                        // const isRed =
                                                        //   jodiValue === "**" ||
                                                        //   redJodis.includes(
                                                        //     jodiValue
                                                        //   );
                                                        const isRed =
                                                          jodiValue === "**" ||
                                                          redJodis.includes(
                                                            jodiValue.replace(
                                                              "*",
                                                              ""
                                                            )
                                                          );

                                                        return (
                                                          <div
                                                            key={`${wIdx}-${dIdx}`}
                                                            className="grid grid-cols-[auto_minmax(12px,16px)_auto] grid-rows-3 bg-white p-[1px] pt-0.5 border border-m_black/20 text-center gap-y-0.5 gap-x-0.5 rounded"
                                                          >
                                                            <span className="tabular-nums text-m_darkgreen font-bold text-[10px] leading-[10px]">
                                                              {openDigits[0]}
                                                            </span>
                                                            <span></span>
                                                            <span className="tabular-nums text-m_red font-bold text-[10px] leading-[11px]">
                                                              {closeDigits[0]}
                                                            </span>
                                                            <span className="tabular-nums text-m_darkgreen font-bold text-[10px] leading-[10px]">
                                                              {openDigits[1]}
                                                            </span>
                                                            <span
                                                              className={`flex items-center justify-center w-full h-full font-bold text-[11px] leading-[12px] ${
                                                                isRed
                                                                  ? "text-red-600"
                                                                  : "text-black"
                                                              }`}
                                                            >
                                                              {jodiValue}
                                                            </span>
                                                            <span className="tabular-nums text-m_red font-bold text-[10px] leading-[11px]">
                                                              {closeDigits[1]}
                                                            </span>
                                                            <span className="tabular-nums text-m_darkgreen font-bold text-[10px] leading-[10px]">
                                                              {openDigits[2]}
                                                            </span>
                                                            <span></span>
                                                            <span className="tabular-nums text-m_red font-bold text-[10px] leading-[11px]">
                                                              {closeDigits[2]}
                                                            </span>
                                                          </div>
                                                        );
                                                      })}
                                                    </div>
                                                  );
                                                })}
                                              </>
                                            ) : (
                                              <div className="w-full grid place-items-center text-gray-500 font-semibold py-4 text-center">
                                                No Results found
                                              </div>
                                            )}
                                          </div>

                                          {/* Desktop view */}
                                          <div className="hidden md:flex flex-col gap-3 w-full mb-4">
                                            {!last7 || last7.length === 0 ? (
                                              <div className="hidden md:flex text-center justify-center py-4 text-gray-500 font-semibold w-full">
                                                No Results Found
                                              </div>
                                            ) : (
                                              last7.map((week, wIdx) => (
                                                <div
                                                  key={wIdx}
                                                  className="flex items-start gap-3"
                                                >
                                                  {/* Week date range */}
                                                  <div className="w-20 flex flex-col leading-none text-m_black text-xxs border px-2 py-2">
                                                    <span className="font-semibold text-center">
                                                      {week[0]?.matchDate ||
                                                        "-"}{" "}
                                                      {/* start of week */}
                                                    </span>
                                                    <span className="text-center text-xs">
                                                      to
                                                    </span>
                                                    <span className="font-semibold text-center">
                                                      {(() => {
                                                        const lastDay =
                                                          week[week.length - 1]
                                                            ?.matchDate;
                                                        if (!lastDay)
                                                          return "-";

                                                        const [d, m, y] =
                                                          lastDay
                                                            .split("-")
                                                            .map(Number);
                                                        const dateObj =
                                                          new Date(y, m - 1, d);
                                                        const day =
                                                          dateObj.getDay();
                                                        if (day !== 0)
                                                          dateObj.setDate(
                                                            dateObj.getDate() +
                                                              (7 - day)
                                                          );

                                                        const dd = String(
                                                          dateObj.getDate()
                                                        ).padStart(2, "0");
                                                        const mm = String(
                                                          dateObj.getMonth() + 1
                                                        ).padStart(2, "0");
                                                        const yyyy =
                                                          dateObj.getFullYear();

                                                        return `${dd}-${mm}-${yyyy}`;
                                                      })()}
                                                    </span>
                                                  </div>

                                                  {/* Days in week */}
                                                  <div className="grid grid-cols-7 gap-2 flex-1">
                                                    {!week ||
                                                    week.length === 0 ? (
                                                      <div className="col-span-7 text-center py-2 text-gray-400">
                                                        No Data
                                                      </div>
                                                    ) : (
                                                      week.map((day, i) => {
                                                        const openDigits = (
                                                          day.singlePattiOpen ||
                                                          "***"
                                                        )
                                                          .toString()
                                                          .split("");
                                                        const closeDigits = (
                                                          day.singlePattiClose ||
                                                          "***"
                                                        )
                                                          .toString()
                                                          .split("");
                                                        let jodiValue = "";
                                                        const openValRaw =
                                                          day.jodiOpen
                                                            ?.toString()
                                                            .trim();
                                                        const closeValRaw =
                                                          day.jodiClose
                                                            ?.toString()
                                                            .trim();

                                                        // Treat "***" as empty
                                                        const openVal =
                                                          openValRaw &&
                                                          openValRaw !== "***"
                                                            ? openValRaw
                                                            : "";
                                                        const closeVal =
                                                          closeValRaw &&
                                                          closeValRaw !== "***"
                                                            ? closeValRaw
                                                            : "";
                                                        const total =
                                                          day.totalJodiValue
                                                            ?.toString()
                                                            .trim();

                                                        if (
                                                          total &&
                                                          total !== "**"
                                                        ) {
                                                          jodiValue = total;
                                                        } else if (
                                                          openVal &&
                                                          closeVal
                                                        ) {
                                                          jodiValue = `${openVal}-${closeVal}`;
                                                        } else if (openVal) {
                                                          jodiValue = `${openVal}*`;
                                                        } else if (closeVal) {
                                                          jodiValue = `*${closeVal}`;
                                                        } else {
                                                          jodiValue = "**";
                                                        }

                                                        const redJodis = [
                                                          "11",
                                                          "22",
                                                          "33",
                                                          "44",
                                                          "55",
                                                          "66",
                                                          "77",
                                                          "88",
                                                          "99",
                                                          "00",
                                                          "16",
                                                          "61",
                                                          "27",
                                                          "72",
                                                          "38",
                                                          "83",
                                                          "49",
                                                          "94",
                                                          "50",
                                                          "05",
                                                        ];
                                                        const isRed =
                                                          jodiValue === "**" ||
                                                          redJodis.includes(
                                                            jodiValue.replace(
                                                              "*",
                                                              ""
                                                            )
                                                          );

                                                        return (
                                                          <div
                                                            key={i}
                                                            className="grid grid-cols-3 grid-rows-3 text-center bg-white shadow-sm border border-m_black/20"
                                                          >
                                                            {/* Row 1 */}
                                                            <span className="text-m_darkgreen font-bold text-xs bg-red-50 px-1 leading-tight">
                                                              {openDigits[0] ||
                                                                ""}
                                                            </span>
                                                            <span></span>
                                                            <span className="text-m_red font-bold text-xs bg-red-50 rounded px-1 leading-tight">
                                                              {closeDigits[0] ||
                                                                ""}
                                                            </span>

                                                            {/* Row 2 */}
                                                            <span className="text-m_darkgreen font-bold text-xs bg-red-50 px-1 leading-tight">
                                                              {openDigits[1] ||
                                                                ""}
                                                            </span>
                                                            <span
                                                              className={`font-bold text-sm rounded px-1 leading-tight ${
                                                                isRed
                                                                  ? "text-red-600"
                                                                  : "bg-emerald-50 text-black"
                                                              }`}
                                                            >
                                                              {jodiValue}
                                                            </span>
                                                            <span className="text-m_red font-bold text-xs bg-red-50 rounded px-1 leading-tight">
                                                              {closeDigits[1] ||
                                                                ""}
                                                            </span>

                                                            {/* Row 3 */}
                                                            <span className="text-m_darkgreen font-bold text-xs bg-red-50 px-1 leading-tight">
                                                              {openDigits[2] ||
                                                                ""}
                                                            </span>
                                                            <span></span>
                                                            <span className="text-m_red font-bold text-xs bg-red-50 rounded px-1 leading-tight">
                                                              {closeDigits[2] ||
                                                                ""}
                                                            </span>
                                                          </div>
                                                        );
                                                      })
                                                    )}
                                                  </div>
                                                </div>
                                              ))
                                            )}
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </TableCell>
                          </TableRow>
                        )}
                      </React.Fragment>
                    );
                  }
                );

                return rows.length > 0 ? (
                  <Table>
                    <TableHeader className="rounded-none">
                      <TableColumn className="text-md bg-m_peach text-m_black">
                        Match Date
                      </TableColumn>
                      <TableColumn className="text-md bg-m_peach text-m_black">
                        Match Name
                      </TableColumn>
                      <TableColumn className="text-md bg-m_peach text-m_black">
                        Result
                      </TableColumn>
                    </TableHeader>
                    <TableBody>{rows}</TableBody>
                  </Table>
                ) : (
                  <div className="text-center justify-center p-4 text-gray-500 font-medium">
                    No results found
                  </div>
                );
              })()
            ) : (
              <div className="text-center justify-center p-4 text-gray-500 font-medium">
                No results found
              </div>
            )}
          </Tab>
        </Tabs>
      </div>
      {/* {timedOut === false && (
        <div className="px-1 mx-auto max-w-screen-xl md:max-w-screen-2xl 2xl:max-w-screen-lg lg:py-5 ">
          {Object.keys(groupedMarkets).length > 0 ? (
            <div>
              {Object.entries(groupedMarkets).map(([marketName, matches]) => (
                <div className="py-1">
                  <div className="w-full bg-m_peach text-m_black mb-1">
                    <h1 className="px-3 py-1 font-semibold">{marketName}</h1>
                  </div>
                  <MarketList
                    marketName={marketName}
                    matches={matches}
                    operatorId={operatorId}
                    userId={userId}
                    tokenFromUrl={tokenFromUrl}
                  />
                </div>
              ))}
            </div>
          ) : (
            <div className="flex items-center justify-center h-96">
              <div className="text-center">
                <h2 className="text-xl font-semibold text-gray-600">
                  No Markets Available
                </h2>
              </div>
            </div>
          )}
        </div>
      )}
      {timedOut && (
        <div className="min-h-screen bg-admin_black flex flex-col items-center justify-center">
          <h1 className="text-white text-3xl font-semibold">
            Session TimeOut.
          </h1>
        </div>
      )} */}
    </div>
  );
};
export default Markets;